import React, { Component } from 'react';
import Outbox from './Outbox.js';

export default class OutboxSuratUndangan extends Component {
  render() {
    return (
      <Outbox type='TNDE_UNDANGAN'/>
    );
  }
}
